import Box from '@mui/material/Box';
import { observer } from 'mobx-react';


import WhiteWallet from "./image/Wallet.png";
import { useStore } from "../../state/MobxContext";
import { makeStyles, useMediaQuery } from "@material-ui/core";
import { Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import { Grid } from '@mui/material';



function WalletBar() {
  const { loginStore } = useStore();
  const { CoinStore } = useStore();
  const { MissionStore } = useStore();

  // const { UserProfileStore } = useStore();



  const useStyles = makeStyles((theme) => ({
    //UserImage
    UserImage: {
      width: "40px",
      height: "40px"
    },
    UserImageMobile: {
      flex: 1,
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    },
    //BasicUserImage
    BasicUserImage: {
      width: "40px",
      height: "40px"
    },
    BasicUserImageMobile: {
      flex: 1,
      width: '100%',
      height: '100%',
      objectFit: 'contain'
    },
    WhiteWalletImage: {
      width: '100%',
      // marginRight: '-265px'

    },
    WhiteWalletImageMobile: {
      width: '80%',
      height: '80%',

      // marginRight: '-265px'
    },


  }));

  const isMobile = useMediaQuery("(max-width: 600px)");
  const isSeven = useMediaQuery("(max-width: 700px)");
  const classes = useStyles();
  const Wallet = CoinStore.WalletData.address;





  const WhiteTextTypography = withStyles({
    root: isMobile ? {
      fontSize: '0.7rem',
      color: "#FFFFFF",
    }
      : {
        fontSize: '1.5rem',
        color: "#FFFFFF",
      }
  })(Typography);
  // onClick={(e) => {loginStore.setDialogOpen("Wallet")}}
  return (
    <div>
      <Grid container direction="row" minWidth='full' justifyContent="space-between" alignItems="center" bgcolor='black' maxWidth='100%' mx='auto' p={1} borderRadius='6px' onClick={(e) => { loginStore.setDialogOpen("Wallet") }} marginTop={isMobile ? "2%" : "1%"} >
        <Grid item xs={12} sm={12} container direction="row" alignItems="center" >
          <Grid item xs={1} sm={isSeven ? 1 : 1} md={1}  >
            <Box sx={isMobile ? { display: 'flex', width: '30px', height: '30px', marginY: "15%" }
              : { display: 'flex', width: '40%', marginY: "5%" }}>
              <img src={WhiteWallet} className={isMobile ? classes.WhiteWalletImageMobile : classes.WhiteWalletImage} alt='WhiteWallet' />
            </Box>
          </Grid>
          <Grid container item xs={11} sm={11} md={11} >
            <WhiteTextTypography>
              {Wallet !== undefined ? Wallet : ''}
            </WhiteTextTypography>
          </Grid>
        </Grid>
        {/* <button onClick={(e) => {MissionStore.getUserMissionLevelInfo(e)}}>test</button> */}
      </Grid>
    </div>
  )
};

export default observer(WalletBar);